import sw1 from '../img/food/sw1.jpeg'
import sw2 from '../img/food/sw2.jpeg'
import sw3 from '../img/food/sw3.jpeg'
import sw4 from '../img/food/sw4.jpeg'
import sw5 from '../img/food/sw5.jpeg'
import sw6 from '../img/food/sw6.jpeg'

import hd1 from '../img/food/hd1.jpeg'
import hd2 from '../img/food/hd2.jpeg'

import n1 from '../img/food/n1.jpeg'
import n2 from '../img/food/n2.jpeg'
import n3 from '../img/food/n3.jpeg'


export const schedule = {
    start: 10,
    end: 22
}

export const address = "ул. Яблочкова 23/2";

export const contact = {
    number: "+7 (996) 472-55-27",
    name: "Бахтияр Д.",
}

const shawBase = ["курица", "огурец", "помидор", "капуста", "корейская морковь", "соус"]
const hotdogBase = ["булочка с кунжутом", "сосика (говядина или курятина)", "горчица", "кетчуп"]
const additionalBase = ["Соус в подарок"]

export const assortment = [
    {
        type: "Шаурма",
        items: 
        [
            {
                name: "Шаурма Классический",
                composition: [],
                cost: 180,
                img: sw1
            },
            {
                name: "Шаурма Сырная",
                composition: ["сыр"],
                cost: 180,
                img: sw2
            },
            {
                name: "Шаурма в Тандыре",
                composition: [],
                cost: 180,
                img: sw3
            },
            {
                name: "Шаурма Острая",
                composition: ["перец халапеньо"],
                cost: 200,
                img: sw4
            },
            {
                name: "Шаурма Грибная",
                composition: ["марионованный шампиньон"],
                cost: 200,
                img: sw5
            },
            {
                name: "Шаурма Детская",
                composition: [],
                cost: 120,
                img: sw6
            },
        ],
    },
    {
        type: "Хот-доги",
        items: 
        [
            {
                name: "Классический",
                composition: [],
                cost: 100,
                img: hd1
            },
            {
                name: "Датский",
                composition: ["маринованные огурцы", "лук"],
                cost: 120,
                img: hd2
            },
        ],
    },
    {
        type: "Дополнительное",
        items: 
        [
            {
                name: "Наггетсы 12 шт.",
                composition: [],
                cost: 160,
                img: n1
            },
            {
                name: "Наггетсы 6 шт.",
                composition: [],
                cost: 90,
                img: n2
            },
            {
                name: "Картофель фри",
                composition: [],
                cost: 100,
                img: n3
            },
        ],
    },
].map(chapter => {
    chapter.items = chapter.items.map(item => {
        if(chapter.type === "Шаурма") {
            item.composition = item.composition.concat(shawBase)
        } else if (chapter.type === "Хот-доги") {
            item.composition = item.composition.concat(hotdogBase)
        } else {
            item.composition = item.composition.concat(additionalBase)
        }

        item.composition = item.composition.map((ingr, ingrIndex) => {
            if(ingrIndex === 0) {
                ingr = ingr[0].toUpperCase() + ingr.slice(1)
            }

            if(ingrIndex !== item.composition.length - 1) {
                ingr = ingr + ", "
            }

            return ingr
        }).join("")

        return item
    })

    return chapter
})
